<template>
  <div>
    <the-header/>
    <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <h3 class="modal-card-title has-text-centered">Actualización de contraseña</h3>
        <p class="has-text-centered header-subtitle">{{ changeTitleModal }}</p>
        <p class="has-text-centered header-subtitle">{{ changeSubTitleModal }}</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="changePassword">
          <div class="field">
            <label for="oldPassword">Contraseña actual</label>
            <div class="control has-icons-right">
              <input
                class="input"
                :type="!showOldPassword ? 'password' : 'text'"
                name="passwors"
                placeholder="Contraseña actual"
                autofocus=""
                autocomplete="off"
                v-model="oldPassword"
              />
              <a
                class="icon is-small is-right"
                @click="viewOldPassword()"
              >
                <i class="far fa-eye" v-if="!showOldPassword"></i>
                <i class="far fa-eye-slash" v-else></i>
              </a>
            </div>
          </div>
          <div class="field">
            <label for="newPassword">Nueva contraseña</label>
            <div class="control has-icons-right">
              <input
                class="input"
                :type="!showNewPassword ? 'password' : 'text'"
                placeholder="Nueva contraseña"
                name="password"
                v-model="newPassword"
                @input="onInput"
              />
              <a
                class="icon is-small is-right"
                @click="viewNewPassword()"
              >
                <i class="far fa-eye" v-if="!showNewPassword"></i>
                <i class="far fa-eye-slash" v-else></i>
              </a>
            </div>
          </div>
          <ul v-if="showValidation && newPassword" class="is-size-7 mt-2">
            <li :class="getClass(validations.minCharacters)">• Al menos 10 caracteres</li>
            <li :class="getClass(validations.lowercase)">• Una letra minúscula</li>
            <li :class="getClass(validations.uppercase)">• Una letra mayúscula</li>
            <li :class="getClass(validations.symbol)">• Un número y un símbolo</li>
          </ul>
          <div class="field">
            <label for="repeatedPassword">Confirmar nueva contraseña</label>
            <div class="control has-icons-right">
              <input
                class="input"
                :type="!showRepeatedPassword ? 'password' : 'text'"
                name="password2"
                placeholder="Repetir contraseña"
                autofocus=""
                autocomplete="off"
                v-model="repeatedPassword"
                @input="inputconfirmPassword"
              />
              <a
                class="icon is-small is-right"
                @click="viewRepeatedPassword()"
              >
                <i class="far fa-eye" v-if="!showRepeatedPassword"></i>
                <i class="far fa-eye-slash" v-else></i>
              </a>
            </div>
          </div>
          <p v-if="notMatch" class="is-error">Las contraseñas no coinciden</p>
          <p v-if="matchPasswords" class="has-text-success is-size-7 has-text-weight-normal">Las contraseñas coinciden</p>
          <button
            :disabled="isButtonDisabled"
            :class="{ 'is-loading': loading }"
            class="button btn-is-blue is-medium is-fullwidth"
          >
          <p>
            Actualizar contraseña
          </p>
          </button>
        </form>
      </section>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'ChangePassword',
  components: {
    TheHeader: () => import('@/components/TheHeader.vue')
  },
  data () {
    return {
      oldPassword: '',
      newPassword: null,
      repeatedPassword: null,
      showNewPassword: false,
      showOldPassword: false,
      showRepeatedPassword: false,
      isMatch: false,
      isValid: false,
      isSamePass: false,
      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{10,}$/,
      loading: false,
      showValidation: false,
      validations: {
        minCharacters: false,
        lowercase: false,
        uppercase: false,
        symbol: false
      },
      notMatch: false,
      isButtonDisabled: true,
      user: {}
    }
  },
  computed: {
    ...mapState({ authentication: state => state.authentication }),
    matchPasswords () {
      if (this.repeatedPassword === this.newPassword && (this.repeatedPassword != null && this.newPassword != null)) {
        return true
      }
      return false
    },
    changeTitleModal () {
      const { passwordConfirm, changePassword } = this.user
      let title = ''
      if (passwordConfirm === false && changePassword === false) {
        title = 'Bienvenido a Intelligential'
      } else if (passwordConfirm === true && changePassword === true) {
        title = 'Tu contraseña ha caducado'
      } else if (passwordConfirm === true && changePassword === false) {
        title = ''
      }
      return title
    },
    changeSubTitleModal () {
      const { passwordConfirm, changePassword } = this.user
      let title = ''
      if (passwordConfirm === false && changePassword === false) {
        title = 'Por seguridad, te pedimos crear una nueva contraseña antes de comenzar'
      } else if (passwordConfirm === true && changePassword === true) {
        title = 'Por seguridad, te pedimos crear una nueva contraseña'
      } else if (passwordConfirm === true && changePassword === false) {
        title = ''
      }
      return title
    }
  },
  methods: {
    ...mapMutations(['setAuthenticationValue']),
    ...mapActions(['changePass', 'profileMe']),
    changePassword () {
      this.loading = true
      this.isButtonDisabled = true
      const data = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }
      this.changePass(data).then(resp => {
        this.loading = false
        this.isButtonDisabled = true
        if (resp) {
          this.$router.push('/')
        }
      })
    },
    viewOldPassword () {
      this.showOldPassword = !this.showOldPassword
    },
    viewRepeatedPassword () {
      this.showRepeatedPassword = !this.showRepeatedPassword
    },
    viewNewPassword () {
      this.showNewPassword = !this.showNewPassword
    },
    onInput () {
      if (!this.showValidation && this.newPassword.length > 0) {
        this.showValidation = true
      } else if (this.newPassword.length <= 0) {
        this.showValidation = false
      }
      this.validatePassword()
    },
    validatePassword () {
      const value = this.newPassword
      this.validations.minCharacters = value.length >= 10
      this.validations.lowercase = /[a-z]/.test(value)
      this.validations.uppercase = /[A-Z]/.test(value)
      this.validations.symbol = /\d/.test(value) && /[^A-Za-z0-9]/.test(value)
    },
    getClass (isValid) {
      return isValid ? 'has-text-success' : 'has-text-danger'
    },
    inputconfirmPassword () {
      this.isButtonDisabled = true
      if (this.repeatedPassword.length > 0 && this.repeatedPassword !== this.newPassword) {
        this.notMatch = true
      } else if (this.repeatedPassword.length > 0) {
        this.notMatch = false
        this.isButtonDisabled = false
      }
    }
  },
  mounted () {
    this.profileMe().then(resp => {
      const { ...user } = resp
      this.user = user
    })
  }
}
</script>
<style lang="scss" scoped>
.resend-code {
  font-weight: 500;
  font-size: 14px;
  display: flex;
  justify-self: flex-end;
}
.modal-card-head {
  display: flex;
  flex-direction: column;
}
.modal-card-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #283056;
  margin-bottom: 10px;
}
.header-subtitle {
  font-size: 0.8rem;
  color: #707070;
}
.modal-card-head, .modal-card-foot {
  background: #FFF;
  border: none;
  padding: 1rem;
}
.modal-card .modal-card-body {
  padding: 0 8.6rem;
}
form {
  margin-top: 20px;
}
form label {
  margin-bottom: 0.3rem;
}
.control.has-icons-left .icon, .control.has-icons-right .icon {
  pointer-events: all;
}
.btn-is-blue {
  margin-top: 2rem;
}
</style>
